import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchreeuwen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="m24.53 35.48-4.48-2.78-4.4 2.92-2.42-4.68-5.27.25.52-5.23-4.53-4.17 4.02-4.71-.87-6.14 6.02-1.37 3.2-5.3 5.26 3.16 5.94-1.55 1.87 5.87L35 14.3l-2.39 5.65 2.92 4.11-4.57 2.13.54 5.01-5.02-.38z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m14.55 4.254 5.508 3.32 5.746-1.498.252.968-6.154 1.603-5.012-3.02-3.052 5.053-5.778 1.325.815 5.674-.99.142-.945-6.586L11.202 9.8z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M20 10.21h2.45l-.42 6.85h-1.57zm1.23 10.55a1.24 1.24 0 0 1-.88-2.11 1.2 1.2 0 0 1 .88-.37 1.16 1.16 0 0 1 .87.37 1.23 1.23 0 0 1-.87 2.11M16 28.81h-.8l.31-1.27h.8l.28-1.17h-.81l.3-1.27h.81l.4-1.66h1.34l-.41 1.66h1l.39-1.66h1.32l-.4 1.66h.79L21 26.37h-.79l-.27 1.17h.78l-.31 1.27h-.81l-.5 2.09h-1.31l.49-2.09h-1l-.5 2.09H15.5zm2.59-1.27.29-1.17h-1l-.27 1.17z"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m27.39 17.02-4.22 5.96h3.23v4.07l4.28-5.98h-3.29zM12.154 15.72A2.16 2.16 0 0 0 10 17.872v.012a2.82 2.82 0 0 0 2.747 2.896 3.65 3.65 0 0 0 3.653-3.641l1 .002a4.65 4.65 0 0 1-4.661 4.639h-.01A3.82 3.82 0 0 1 9 17.862a3.16 3.16 0 0 1 3.16-3.142h.012a2.63 2.63 0 0 1 2.568 2.687 2.21 2.21 0 0 1-2.21 2.193v-1a1.21 1.21 0 0 0 1.21-1.203v-.009a1.63 1.63 0 0 0-1.586-1.668"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchreeuwen);

export default ForwardRef;
